import type { DisplayConfigItem } from '@rsos/reduxDataStore/src/features/eventShare/types';

/** Share session lifetime — links expire after 24 hours per product spec (IAR-41050). */
export const SHARE_EXPIRY_SECONDS = 24 * 60 * 60;

/**
 * Display config items always sent for IaR shares. The map is required so the
 * Connect Share view shown to responders includes the location pin alongside
 * any user-selected data sources.
 */
export const IAR_DEFAULT_DISPLAY_CONFIG: DisplayConfigItem[] = [
  { name: 'map', meta: {} },
];
